import axios from "../../config/axiosConfig";
import { LOCK_DATA_REQUEST, SET_LOCK_DATA, LOCK_DATA_REQUEST_FAILURE } from "../types";

export const getLockData = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LOCK_DATA_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id }; //Need to discuss

      return axios.get("/lock-data/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: SET_LOCK_DATA, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: LOCK_DATA_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: LOCK_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const saveLockData = (id, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: LOCK_DATA_REQUEST });

      return axios.put("/lock-data/save", { id, data }, 
        { params: { companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
          if (response.data) {
            dispatch({ type: SET_LOCK_DATA, payload: response.data });
          } else {
            dispatch({
              type: LOCK_DATA_REQUEST_FAILURE,
              error: "Save lock data failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: LOCK_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: LOCK_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateLockDataPassword = (id, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      return axios.put("/lock-data/update-password", { id, data }, 
        { params: { companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: LOCK_DATA_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: LOCK_DATA_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
      throw error;
    }
  };
};